<div class="header-title">
    <div class="flex u-align-items-center u-pa-20">
        <div class="flex flex-align-center">
            <a routerLink="/button" aria-label="back"
                class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
                <span class="u-icon icon-chevron-left"></span>
                <span class="u-button-text">Back</span>
            </a>
        </div>
        <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
            <h1 class="font-semibold u-ma-0 flex header-title--name">Side Panel</h1>
        </div>
    </div>
    <div class="c-header__gradient"></div>
</div>
<div class="content content--side-panel-wrapper">
    <div class="content__aside">
        <maced-side-panel [ariaLabels]="showAriaLabelEnglish" sidePanelID="sidepanel1" [levelProjectedContent]="false"
        [isPanelOpen]="isPanelOpen" [panelPositionBorder]="panelPositionLeft" iconLeft="cancelIcon" title="left Panel">
        <ng-container ngProjectAs="[panelHeader]">
            <h2 class="c-side-panel__title-text">left Panel</h2>
        </ng-container>
        <ng-container ngProjectAs="[panelBody]">
                <div class="content-block-aside">
                    <span>Content goes here</span>
                </div>
            </ng-container>
        </maced-side-panel>&nbsp;

        <maced-side-panel [ariaLabels]="showAriaLabelSpanish" sidePanelID="sidepanel3" [levelProjectedContent]="false"
        [isPanelOpen]="isPanel2Open" [panelPositionBorder]="panelPositionLeft" 
        iconLeft="cancelIcon" iconRight="backIcon" title="panel izquierdo">
        <ng-container ngProjectAs="[panelHeader]">
            <h2 class="c-side-panel__title-text">panel izquierdo</h2>
        </ng-container>
            <ng-container ngProjectAs="[panelBody]">
                <div class="content-block-aside">
                    <span>El contenido va aquí</span>
                </div>
            </ng-container>
        </maced-side-panel>&nbsp;
    </div>
    <div class="content__aside">
        <maced-side-panel [ariaLabels]="showAriaLabelHindi" sidePanelID="sidepanel2" 
        [isPanelOpen]="isPanel1Open"  [panelPositionBorder]="panelPositionRight"
         iconLeft="backIcon" iconRight="cancelIcon" title="दायां पैनल">
            <ng-container ngProjectAs="[panelBody]">
                <div class="content-block-aside">
                    <span>सामग्री यहाँ जाती है</span>
                </div>
            </ng-container>
        </maced-side-panel>
    </div>
</div>